import gsap from "gsap";
import { WindowWidthContext } from "../App";
import { useContext, useEffect, useState } from "react";

function About() {
  const [isMobile, setIsMobile] = useState("");
  const windowWidth = useContext(WindowWidthContext);

  useEffect(() => {
    if (windowWidth > 1000) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  }, [windowWidth]);

  useEffect(() => {
    if (isMobile !== "") {
      const tl = gsap.timeline();

      tl.set(".home__about", {
        visibility: "visible",
      })
        .from(
          ".home__about__line1",
          !isMobile
            ? {
                scaleX: 0,
                transformOrigin: "left",
                duration: 0.8,
              }
            : {}
        )
        .from(".home__about__container0 p", {
          x: -50,
          duration: 0.8,
          opacity: 0,
        })
        .from(
          ".home__about__container0 .home__about__container__img-container",
          {
            x: 50,
            opacity: 0,
            duration: 0.8,
          },
          0.8
        )
        .from(
          ".home__about__container1 .home__about__container__img-container",
          {
            x: -50,
            opacity: 0,
            duration: 0.8,
          },
          0.8
        )
        .from(
          ".home__about__container1 p",
          {
            x: 50,
            duration: 0.8,
            opacity: 0,
          },
          0.8
        )
        .from(
          ".home__about__line2",
          !isMobile
            ? {
                scaleX: 0,
                transformOrigin: "right",
                duration: 0.8,
              }
            : {}
        );
    }
  }, [isMobile]);

  return (
    <div className="home__about">
      <div className="home__about__line home__about__line1"></div>
      <div className="home__about__container home__about__container0">
        <p>
          <span>Industry Lorem Ipsum has been the industry's</span> standard
          dummy text ever since the 1500s, when an unknown printer took a galley
          of type and scrambled it to make a type specimen book. It has survived
          not only five centuries, but also the leap into electronic
          typesetting, remaining essentially unchanged. It was popularised
          standard dummy text ever since the 1500s, when an unknown printer took
          a galley of type and scrambled it to make a type specimen book. It has
          survived not only five centuries, but also the leap into electronic
          typesetting, remaining essentially unchanged. It was popularised
        </p>
        <div className="home__about__container__img-container">
          <img src="/images/about1.webp" />
        </div>
      </div>
      <div className="home__about__container home__about__container1">
        <div className="home__about__container__img-container">
          <img src="/images/about2.webp" />
        </div>
        <p>
          Standard dummy text ever since the 1500s, when an unknown printer took
          a galley of type and scrambled it to make a type specimen book. It has
          survived not only five centuries, but also the leap into electronic
          typesetting, remaining essentially unchanged. It was popularised
          standard dummy text ever since the 1500s, when an unknown printer took
          a galley of type and scrambled it to make a type specimen book. It has
          survived not only five centuries, but also the leap into electronic
          typesetting, remaining essentially unchanged. It was popularised
        </p>
      </div>
      <div className="home__about__line home__about__line2"></div>
    </div>
  );
}

export default About;
